import type { PropsWithChildren } from 'react';
import { Platform, Pressable } from 'react-native';
import type { PressableProps } from 'react-native';

import { cn } from '../utils/cn';

// RN-Web-only: `href` on Pressable renders as `<a href="...">`. Ignored on native.
type BaseButtonProps = PropsWithChildren<PressableProps & { href?: string }>;

export const BaseButton = (props: BaseButtonProps) => {
  const { children, className, disabled, href, accessibilityRole, ...rest } = props;

  return (
    <Pressable
      className={cn(
        'active:opacity-80 hover:opacity-80',
        { 'cursor-pointer': Platform.OS === 'web' && !disabled },
        className
      )}
      disabled={disabled}
      accessibilityRole={accessibilityRole ?? (href != null ? 'link' : 'button')}
      // @ts-expect-error react-native-web-only prop, not in PressableProps
      href={href}
      {...rest}
    >
      {children}
    </Pressable>
  );
};
